// extracted by mini-css-extract-plugin
export default {"borderWrapper":"form_borderWrapper__WWi0L","wrapper":"form_wrapper__Rk-CX","header":"form_header__dKMN6","back":"form_back__YShBx"};